import { useNavigate, useParams } from 'react-router'

import LeftChevronIcon from '@/assets/icons/icon-chevron-left.svg'
import RightChevronIcon from '@/assets/icons/icon-chevron-right.svg'
import { Button } from '@/components/ui/button.tsx'
import { AppRoutes } from '@/utils/constants'

import { courseVideos } from '../../data/course-videos.ts'
import { useCourse } from '../../hooks/useCourse'

export const SwitchCategoryButtons = () => {
  const { setCurrentVideo } = useCourse()
  const { category } = useParams()
  const navigate = useNavigate()

  const handleButtonClick = (counter: number) => () => {
    const currentCategoryIndex = courseVideos.findIndex(
      (c) => c.name === category,
    )
    const videoSet = courseVideos[currentCategoryIndex + counter]

    setCurrentVideo(videoSet.videos[0].video_id)
    navigate(AppRoutes.Courses.Details.asUrl(videoSet.name))
  }

  return (
    <div className="flex items-center justify-end gap-2">
      <Button
        disabled={category === courseVideos[0].name}
        variant="outline"
        onClick={handleButtonClick(-1)}
        className="w-[170px] max-sm:w-[160px]"
      >
        <LeftChevronIcon className="h-5 w-5 fill-secondary-500" />
        Previous Playlist
      </Button>
      <Button
        disabled={category === courseVideos[courseVideos.length - 1].name}
        variant="outline"
        onClick={handleButtonClick(+1)}
        className="w-[170px] max-sm:w-[135px]"
      >
        Next Playlist
        <RightChevronIcon className="h-5 w-5 fill-secondary-500" />
      </Button>
    </div>
  )
}
